import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take } from "rxjs";
import { CredentialStore } from "../../authentication/data-access/credential.store";
import { sessionFeature } from "../../authentication/store/session.reducer";

export const azureLinkingAccessGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    const credentials = inject(CredentialStore);

    return combineLatest([
        store.select(sessionFeature.selectIsSettled),
        store.select(sessionFeature.selectUser),
    ]).pipe(
        filter(([settled]) => settled),
        take(1),
        map(([, user]) => {
            const isClientOwner = Boolean(user?.roles.includes("client_owner"));
            const isAzureSession = credentials.readTokens()?.source === "azure";
            return isClientOwner && !isAzureSession
                ? true
                : router.createUrlTree(["/dashboard"]);
        })
    );
};
